export default __webpack_public_path__ + "static/montserrat-v15-latin-900italic-043b17f9ee5b216d6f20fec1ae71253a.ttf";